var map = {
	"./Benmo-Ziyu.ttf": 18873,
	"./active.png": 21166,
	"./bg.jpg": 63013,
	"./bottom.png": 90007,
	"./head.png": 98264,
	"./l1-icon.png": 53873,
	"./piebg.png": 3153,
	"./piebg2.png": 752,
	"./piebg3.png": 86953,
	"./piebg5.png": 35019,
	"./title1.png": 23287,
	"./title2.png": 90326,
	"./tooltip.png": 60625,
	"./tuwen4-bg.png": 96385,
	"./tuwen4-main.png": 81445,
	"./zge0.png": 85653,
	"./zge1.png": 94845,
	"./zge2.png": 56693,
	"./zge3.png": 98853,
	"./zge4.png": 32233,
	"./zge5.png": 84359,
	"./zge6.png": 54800,
	"./zge7.png": 24830,
	"./zge8.png": 3202,
	"./zge9.png": 91936,
	"./zgeMap.png": 38296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30922;